<div class="select-container">
  <h2 class="ion-no-margin">{{ label }}</h2>
  @if (description) {
    <div [innerHTML]="description"></div>
  }
  <div class="options-container">
    @for(option of options; track $index) {
      <div 
        class="option" 
        [class.selected]="option.id === selectedOption?.id"
        (click)="selectOption(option)">
        {{ option.value }}
      </div>
    }
  </div>
</div>